import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import type { GetShareUserDataFormButtonProps } from '../../types'

export const getShareUserDataFormButton = ({ t, openForm }: GetShareUserDataFormButtonProps) =>
  ({
    onClick: openForm,
    label: t('shareUserData.buttons.fillForm'),
    testId: 'share-user-data_fill-form',
  } as Action)
